import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import Plotly from 'plotly.js-dist-min';
import store from '../../store';
import {
	selectSolarPVPlotData1, selectSolarPVPlotData2, selectSolarPVPlotData3,
	selectSolarPVPlotData4
} from '../solarSelectors';

@customElement('solar-pv-graph')
export class solarPvGraph extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: flex;
			width: 100%;
		}
		.js-fill {
			fill: url(#fillgradient) !important;
		}
		.solarPvGraph {
			overflow: hidden;
		}
	`;

	plotOptions = {
		showSendToCloud: false,
		displayModeBar: false,
		showlegend: false,
		staticPlot: true,
		scrollZoom: false
	};
	plotLayout = {
		xaxis: {
			showgrid: false,
			ticks: 'outside',
			color:  '#939393',
			tickcolor: '#939393',
			ticklen: 1,
			showticklabels: true,
			tickvals: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
			ticktext: ['', '', 'März', '', '', 'Juni', '', '', 'Sep', '', '', '']

		},
		yaxis: {
			showgrid: false,
			tickcolor: '#fff',
			ticks: '',
			showticklabels: false,
			autorange: false,
			range: [0, 1200]
		},
		width: 280,
		height: 180,
		margin: {
			t: 0,
			b: 30,
			r: 0,
			l: 0
		},
		font: {
			color: '#fff',
		},
		autosize: false,
		paper_bgcolor: 'transparent',
		plot_bgcolor: 'transparent',
	};

	@property({type: Number})
	generators = 1;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.solar = state.solar.data;
		this.lang = state.status.lang;
		this.translations = state.productData.translations;
		switch (this.generators) {
			case 1:
				this.plotData = selectSolarPVPlotData1(state);
				break;
			case 2:
				this.plotData = selectSolarPVPlotData2(state);
				break;
			case 3:
				this.plotData = selectSolarPVPlotData3(state);
				break;
			case 4:
				this.plotData = selectSolarPVPlotData4(state);
				break;
		}
	}

	firstUpdated() {
		this.plot(false);
	}

	updated() {
		this.plot(true);
	}

	plot(redraw) {
		this.plotLayout.xaxis.ticktext = ['', '', msg('March'), '', '', msg('June'), '', '', msg('Sep'), '', '', ''];
		const plotElement = this.shadowRoot.getElementById('plot');
		if (plotElement && this.plotData) {
			Plotly.newPlot(plotElement,
				this.plotData,
				this.plotLayout,
				this.plotOptions
			);
		}
	}

	render() {
		return html`
			<div class="solarPvGraph">
				<div id="plot"></div>
				<svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" viewBox="0 0 0 0" fill="none">
					<defs>
						<linearGradient id="fillgradient" gradientTransform="rotate(90)">
							<stop stop-color="#0ED45D"/>
							<stop offset="1" stop-color="#064A21" stop-opacity="0.13"/>
						</linearGradient>
					</defs>
				</svg>
			</div>

		`;

	}
}
